import React, { type CSSProperties, type PropsWithChildren } from "react";

/// @deprecated Use MuiImageBackground or MuiImage
export const BgImage: React.FC<
	PropsWithChildren<{
		image?: {
			base64?: string | null;
			width?: number;
			height?: number;
			src?: string;
			srcSet?: string;
			srcWebp?: string | null;
			srcSetWebp?: string | null;
		} | null;
		style?: CSSProperties;
	}>
> = ({ children, style, image }) => {
	return (
		<div
			style={{
				backgroundPosition: "right top",
				backgroundRepeat: "no-repeat",
				backgroundSize: "350px 365px",
				width: "100%",
				height: "100%",
				backgroundImage: image && image.src ? 'url("' + image.src + '")' : "",
				...style,
			}}
		>
			{children}
		</div>
	);
};
